import { render, staticRenderFns } from "./IndicatorWithSubtitleAndDelta.vue?vue&type=template&id=48354e4c&"
import script from "./IndicatorWithSubtitleAndDelta.vue?vue&type=script&lang=js&"
export * from "./IndicatorWithSubtitleAndDelta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IndicatorWithSubtitleAndDelta.vue"
export default component.exports